import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AttendedStuentCount, UniversityCount } from "../actions/eventAction";

export default function UniversityStudent({ CommentOpen, setCommentOpen }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { University_Count } = useSelector((s) => s.UniversityCountReducer);
  const { attendedCount } = useSelector((s) => s.AttendedStuentCountReducer);
  const guestCrm = JSON.parse(localStorage.getItem("guestCrm"));
  useEffect(() => {
    dispatch(UniversityCount(id));
    dispatch(AttendedStuentCount(id, guestCrm));
  }, [id]);

  return (
    <>
      <div class="stats-grid">
        <div class="stat-card stat-card-blue">
          <p class="stat-label">Expected Student</p>
          <p class="stat-value">
            {University_Count?.matched_university_count || 0}
          </p>
        </div>
        <div
          class="stat-card stat-card-cyan"
          onClick={() => setCommentOpen(true)}
        >
          <p class="stat-label">Attended</p>
          <p class="stat-value">
            {" "}
            {attendedCount?.length ? attendedCount[0]?.Attend_Count : 0}
          </p>
        </div>
      </div>
      {/* <div className="StudentCount">
        <div>
          <div>Expected Student</div>
          <div>{University_Count?.matched_university_count || 0}</div>
        </div>
        <div onClick={() => setCommentOpen(true)}>
          <div>Attended</div>
          <div>
            {attendedCount?.length ? attendedCount[0]?.Attend_Count : 0}
          </div>
        </div>
      </div> */}
    </>
  );
}
